
import Dashboard from '../Pages/Dashboard';
import Homepage from '../Pages/Homepage';


// Master Section Link Start
  import Master_area from '../Pages/master/area';
  import Master_users from '../Pages/master/users';
  import Master_delman from '../Pages/master/delman';
  import Master_customer from '../Pages/master/customer';
  import Master_category from '../Pages/master/category';
  import Master_product from '../Pages/master/product';
  import Master_welcome_image from '../Pages/master/welcome_image';
  import Master_wapi_login from '../Pages/master/wapi_login';
// Master Section Link End

// Transaction Section Link Start
  import Trans_order from '../Pages/transaction/order';
  import Trans_packing from '../Pages/transaction/packing';
  import Trans_purchase from '../Pages/transaction/purchase';
  import Trans_sales from '../Pages/transaction/sales';
  import Trans_wasteg from '../Pages/transaction/wasteg';
  import Trans_cash_entry from '../Pages/transaction/cash_entry';
// Transaction Section Link End


// Delevery Partner Section Link Start
  import Del_shift_master from '../Pages/partner/del_shift_master';
// Delevery Partner Section Link End


// Account Section Link Start
   import Acc_accparty from '../Pages/account/accparty';
   import Acc_hsncode from '../Pages/account/hsncode';
   import Acc_expence from '../Pages/account/expence';
// Account Section Link End

// Report Section Link Start
   import Report_ord_prd from '../Pages/report/order_product';
   import Report_stock from '../Pages/report/stock';
   import Report_PL from '../Pages/report/PL';
// Report Section Link End    

// Marketing Section Link Start
   import Mkt_notification from '../Pages/marketing/notification';
// Marketing Section Link End  

// Utility Section Link Start
   import StikerPrint from '../Pages/utility/StikerPrint';
// Utility Section Link End   


const routes = [
  { path: '/dashboard', element: <Dashboard /> },
  { path: '/Homepage', element: <Homepage /> },

  // Master Section Routes Start
      { path: '/Master_area', element: <Master_area /> },
      { path: '/Master_users', element: <Master_users /> },
      { path: '/Master_delman', element: <Master_delman /> },
      { path: '/Master_customer', element: <Master_customer /> },
      { path: '/Master_category', element: <Master_category /> },
      { path: '/Master_product', element: <Master_product /> },   
      { path: '/Master_welcome_image', element: <Master_welcome_image /> },
      { path: '/Master_wapi_login', element: <Master_wapi_login /> },
  // Master Section Routes End

  // Transaction Section Routes Start
      { path: '/Trans_order', element: <Trans_order /> },
      { path: '/Trans_packing', element: <Trans_packing /> },
      { path: '/Trans_purchase', element: <Trans_purchase /> },
      { path: '/Trans_sales', element: <Trans_sales /> },
      { path: '/Trans_wasteg', element: <Trans_wasteg /> },
      { path: '/Trans_cash_entry', element: <Trans_cash_entry /> },
  // Transaction Section Routes End 


  // Delivery Partner Section Routes Start
      { path: '/Del_Shift_Master', element: <Del_shift_master /> },
  // Delivery Partner Section Routes End 


  // Account Section Routes Start 
      { path: '/Acc_accparty', element: <Acc_accparty /> },
      { path: '/Acc_hsncode', element: <Acc_hsncode /> },
      { path: '/Acc_expence', element: <Acc_expence /> },
  // Account Section Routes End

  // Report Section Routes Start 
      { path: '/Report_ord_prd', element: <Report_ord_prd /> },
      { path: '/Report_stock', element: <Report_stock /> },
      { path: '/Report_PL', element: <Report_PL /> },
  // Report Section Routes End 

  // Marketing Section Routes Start 
      { path: '/Mkt_notification', element: <Mkt_notification /> },
  // Marketing Section Routes End 

  // Utility Section Routes Start 
      { path: '/StikerPrint', element: <StikerPrint /> },
  // Utility Section Routes End    

  { path: '/', element: <Homepage /> }, // default route
];

export default routes;

            

